import { CAT, LANG_CATS, LANG_V2, MAS, NAR, REC, REP_SEC, SUB } from '../Data/typeDirs'
import { genId } from '../utils'
import { langTypeMap } from '../Data/langTypeMap'
// import { MASK_FLAG } from '../ControlManager/scripts/utils'
// import { upgradeOldLang } from '../ControlManager/scripts/legacy'

class Language_v2 {

  constructor(data) {
    this._id = data._id
    this.name = data.name
    this._createdBy = data._createdBy
    this._modifiedBy = data._modifiedBy
    this.created = data.created
    this.modified = data.modified
    this.schema = {
      _id: genId(),
      name: 'temp',
      content: [
        {
          name: 'rootcontainer',
          type: 'Container',
          displaySettings: { as: 'Container', style: { width: '100%', maxWidth: '100%' } },
          children: [
            {
              name:'ratings_sectionsContainer',
              type: 'Container',
              displaySettings: {as: 'Row'},
              children: [
                {
                  name: 'report_sections',
                  type: 'MultiSelect',
                  source:'report_sections',
                  label:'Report Sections',
                  displaySettings: {as: 'Col'}
                },
                {
                  name: 'ratings',
                  type: 'MultiSelect',
                  source:'ratings',
                  label:'Ratings',
                  displaySettings: {as: 'Col'}
                }
              ]
            },
            {
              name: 'categoryContainer',
              type: 'Container',
              displaySettings: { as: 'Row' },
              children: [
                {
                  name: 'mastercategories',
                  type: 'MultiSelect',
                  source: 'mastercategories',
                  displaySettings: { as: 'Col' },
                  label: 'Mastercategories',
                },
                {
                  name: 'categories',
                  type: 'MultiSelect',
                  source: 'categories',
                  label: 'Categories',
                  displaySettings: { as: 'Col' },
                  parent: 'mastercategories'
                },
                {
                  name: 'subcategories',
                  type: 'MultiSelect',
                  source: 'subcategories',
                  label: 'Subcategories',
                  displaySettings: { as: 'Col' },
                  parent: 'categories'
                }
              ]
            },
            {
              name: 'recContainer',
              type: 'Container',
              displaySettings: { as: 'Row' },
              children: [
                {
                  name: 'narratives',
                  type: 'MultiSelect',
                  source: 'narratives',
                  label: 'Narratives',
                  displaySettings: { as: 'Col' },
                  parent: 'subcategories'
                },
                {
                  name: 'recommendations',
                  type: 'MultiSelect',
                  source: 'recommendations',
                  label: 'Recommendations',
                  displaySettings: { as: 'Col' },
                  parent: 'subcategories'
                }
              ]
            },


          ]
        }
      ]
    }


    const {
      mastercategories,
      categories,
      subcategories,
      narratives,
      recommendations,
      report_sections,
      ratings
    } = Language_v2.createSourceChildren(data)
    this.source = {
      mastercategories,
      categories,
      subcategories,
      narratives,
      recommendations,
      report_sections,
      ratings
    }
    // this.content = 
  }
  static getLanguageRelTypeDir(lang_type) {
    return `${LANG_V2}-${lang_type}`
  }

  static async handleDbPut(type, file, user, fileModels) {
    const { Main } = fileModels[type]
    let previousLang = await Main.findOne({ _id: file._id })
    previousLang = previousLang && previousLang.toObject()

    // let previousLang = await Main.findOne({_id: file._id})
    const nowTime = Date.now()
    const UPSERT = { upsert: true, new: true }

    let meta = {
      _createdBy: user._id,
      _modifiedBy: user._id,
      modified: nowTime,
      created: nowTime
    }
    const LANG_V2_DBIDX = `_${LANG_V2}`
    // create new lang

    //manage rels
    // set {_changed: true} on client if something changed?
    // otherwise, must diff, which is kind of lame and expensive 
    let { _modifiedBy, modified } = meta
    if (!file.created) {
      file.created = meta.created
      file._createdBy = meta._createdBy
    }

    let { mastercategories, subcategories, categories, recommendations, narratives, report_sections, ratings, ...langRest } = file
    // console.log('about to put language file')
    await Main.findOneAndUpdate(
      { _id: file._id },
      { ...langRest, _modifiedBy, modified },
      UPSERT
    )
    // console.log('put lang file, now to rels')
    for (let lang_type of LANG_CATS) {
      const TYPE_DB_IDX = `_${lang_type}`
      const relTableName = `${LANG_V2}-${lang_type}`
      let { Main: RelTypeTable } = fileModels[relTableName]
      let currentLangEntries = file[lang_type] || []
      let previousLangEntries = previousLang ? previousLang[lang_type] : []

      for (let item of currentLangEntries) {
        if (item._changed) {
          let { _changed, _id, rel_id, ...rest } = item
          console.log('item changed, putting changes', item.content)
          const { Main: LangTypeMain } = fileModels[lang_type]
          if (!rest.created) {
            rest.created = meta.created
            rest._createdBy = meta._createdBy
          }
          await LangTypeMain.updateOne(
            { _id: _id },
            { _id, ...rest, _modifiedBy, modified },
            UPSERT
          )
        }

      }
      const BIN_SIZE = 50
      for (let i = 0; i < currentLangEntries.length; i += BIN_SIZE) {
        let bin = currentLangEntries.slice(i, i + BIN_SIZE)
        let rels = await RelTypeTable.find({ _id: { $in: bin.map(itm => itm.rel_id) } })
        console.log('bin and rels length', lang_type, bin.length, rels.length)
        if (bin.length !== rels.length) {
          let newRels = bin.filter(itm => (!rels.find(rel => `${rel._id}` === `${itm.rel_id}`)))

          console.log('newrels length', lang_type, newRels.length, file._id)
          for (let rawNewRel of newRels) {
            // console.log('rawnewrel', rawNewRel)
            if (!rawNewRel._id) continue
            const recToPut = { [LANG_V2_DBIDX]: file._id, [TYPE_DB_IDX]: rawNewRel._id }
            let newRel = new RelTypeTable(recToPut)
            await newRel.save()
          }
        }

      }


      console.log('done putting rels for', lang_type)
      let deletedCount = 0
      for (let prevItem of previousLangEntries) {
        let stillExists = currentLangEntries.find(itm => {

          return `${prevItem._id}` === `${itm.rel_id}`
        })
        //not in new data so delete
        if (!stillExists) {
          await RelTypeTable.findOneAndDelete({ _id: prevItem._id })
          deletedCount++
          console.log('found something to delete', type, deletedCount)
        }
      }
      console.log('done deleting rels for', lang_type)
    }


    return await Main.findOne({ _id: file._id })

  }

  static createSourceChildren(data) {
    let source = {}
    for (let type in langTypeMap) {
      // if(type === REP_SEC) console.log('making childrens', type, data[type], data)
      source[type] = data[type] && data[type].map(itm => new langTypeMap[type](itm))
      if ([NAR, REC].includes(type)) {
        Language_v2.sortLangEntries(source, type)
        // source[type].sort(Language_v2.sortLangEntries)
      } else if( [MAS, CAT, SUB].includes(type) ) {
        Language_v2.sortCategories(source, type)
      }
    }
    return source
  }

  static sortLangEntries(source, type) {
    source[type].sort((a, b) => {
      let a_parent_num = source[langTypeMap[type].getParentKey()].find(itm => itm._id === a[langTypeMap[type].getParentAddress()])
      let b_parent_num = source[langTypeMap[type].getParentKey()].find(itm => itm._id === b[langTypeMap[type].getParentAddress()])
      a_parent_num = a_parent_num && a_parent_num.fullNumber
      b_parent_num = b_parent_num && b_parent_num.fullNumber
      return a_parent_num >= b_parent_num ? 1 : -1
    })
  }


  static sortCategories(source, type) {
    // console.log('wat', source, type, source[type])
    source[type].sort((a, b) => {
      return a.fullNumber > b.fullNumber ? 1 : -1
    })
  }

  static getIndices() {
    return '_id,name'
  }

  static async copyToOppositeRem(original, fileModels, oppRemDb) {
    // let putChildrenToOppRem = async (children, type)=>{
    //   const bin_max = 50
    //   console.log('putting type', type)
    //   for( let i = 0; i < Math.ceil(children.length / bin_max); i++ ) {

    //     let s = i * bin_max
    //     let f = (i+1) * bin_max
    //     let bin = children.slice(s,f)
    //     await oppRemDb.gen('bulkInsert', type, bin)

    //   }
    // }
    // // let {mastercategories, categories, subcategories, recommendations, narratives} = original
    // for(let t of LANG_CATS){
    //   console.log('looking for children of type', t, original[t].length)
    //   let cats = await fileModels[t].find({_language_v2:original._id})
    //   console.log('got db data for cats', cats.length, cats)
    //   await putChildrenToOppRem(cats, t)
    //   // original[t] = original[t].map(itm=>({...itm, _changed:true}))
    //   // for(let itm of original[t]) itm._changed = true
    // }
    original = await original.toObject()
    return await oppRemDb.put(LANG_V2, Language_v2.prepareForMetastory(original))

  }

  getSchemas() {
    return [this.schema]
  }

  getDefaultContent() {
    return [{
      _id: genId(),
      schema: 'temp',
      mastercategories: '',
      categories: '',
      subcategories: '',
      narratives: '',
      recommendations: ''
    }]
  }

  getSource() {
    return this.source
  }

  async generateForm(db) {
    let all = {}
    for (let type of LANG_CATS) {
      let arr = await db('remDb')[type].toArray()
      all[type] = arr
    }
    return this.formGenerator.getForm({ controls: this.getControls(), source: { ...this.getSource(), all } })
  }


  static getTypeDir() {
    return LANG_V2
  }

  static prepareForMetastory(data) {
    for (let type of LANG_CATS) {
      data[type] = data[type].map(itm => ({ ...itm[`_${type}`], rel_id: itm._id }))
    }
    return data
  }

  toOldLanguage() {
    let findChildren = (type, _id) => {
      return this.source[type].reduce((acc, itm, idx) => {

        let parentAddress = langTypeMap[type].getParentAddress()
        let childTypes = langTypeMap[type].getChildTypes()
        // console.log('looking for parent', parentAddress, itm, _id)
        if (itm[parentAddress] === _id) {
          let oldEntry = itm.toOldLangEntry()
          for (let childType of childTypes) {
            let children = findChildren(childType, itm._id)
            oldEntry[childType] = children
          }

          acc.push(oldEntry)
          return acc
        }

        return acc
      }, [])
    }
    let obj = { language: { mastercategories: [] } }
    console.log("this.source?", this.source)
    for (let itm of this.source.mastercategories) {
      let children = findChildren(CAT, itm._id)
      let newSourceItem = itm.toOldLangEntry()
      newSourceItem.categories = children
      obj.language.mastercategories.push(newSourceItem)
    }

    return obj
  }


}



export default Language_v2

/* 
contents:[{
  _id:ObjectID||genId(), 
  type/schema:['preamble' | 'report' | 'temp'], 
  ...
}]
schemas:[{
  _id:ObjectID,
  name: String ['preamble' ...]
  content: SchemaObject (JSON)
}]
source:{
  addresses....
}
*/
